import Card from "../../../components/card/card";
import { useContext } from "react";
import Header from "../../../components/header/header";
import { NoPetFoundSvg } from "../../../../../assets/svgComponents";
import {
  USER_APPOINTMENT_ACTIONS,
  UserAppointmentContext,
} from "../../../context/user-appointment-context";

const NoPetDetails = () => {
  const {
    state: { activeStep },
    userDispatcher,
  } = useContext(UserAppointmentContext);

  return (
    <Card
      title={"Choose pets"}
      btnTitle={"Add Pet"}
      onHandleClick={() =>
        userDispatcher({
          type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
          payload: activeStep + 1,
        })
      }
      progress={activeStep * 5}
    >
      <div className="main-wrapper">
        <NoPetFoundSvg />
        <Header
          iscenteraligned
          title="No pet found"
          description={
            "There is no pet registered against your account. Please add and select pets to continue."
          }
        />
      </div>
    </Card>
  );
};

export default NoPetDetails;
